'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _artTemplate = require('art-template');

var _artTemplate2 = _interopRequireDefault(_artTemplate);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

var _Activator = require('../Activator');

var _Activator2 = _interopRequireDefault(_Activator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogsViewRender = function () {
    function LogsViewRender() {
        (0, _classCallCheck3.default)(this, LogsViewRender);

        this.renderAsync = this.renderAsync.bind(this);
    }

    (0, _createClass3.default)(LogsViewRender, [{
        key: 'renderAsync',
        value: function renderAsync(callBack) {
            var plugin = _Activator2.default.context.plugin;
            var logsView = _path2.default.join(plugin.pluginDirectory, 'views/logs.html');
            var logFile = _path2.default.resolve('./log.log');

            if (!_fs2.default.existsSync(logFile)) {
                callBack('');
                return;
            }

            _fs2.default.readFile(logFile, 'utf-8', function (error, data) {
                var logsData = {
                    logs: data.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\r/g, '<br/>').replace(/(ERROR)/g, '<font color=red>ERROR</font>').replace(/(WAIN)/g, '<font color=yellow>WAIN</font>').replace(/(INFO)/g, '<font color=green>INFO</font>')
                };

                callBack((0, _artTemplate2.default)(logsView, logsData));
            });
        }
    }]);
    return LogsViewRender;
}();

exports.default = LogsViewRender;
//# sourceMappingURL=LogsViewRender.js.map